export enum WebRoute {
  REGISTER = '/create-account',
  ACCOUNT_CREATED = '/account-created',
  RESET_PASSWORD_CONFIRMATION = '/password-reset-confirmation',
  RESET_PASSWORD = '/resetPassword',
  LOGIN_SUCCESS = '/login-success',
  LOGOUT_SUCCESS = '/logout-success',
  FORGOT_PASSWORD = '/forgot-password',
  FORGOT_PASSWORD_SUBMITTED = '/forgot-password-submitted',
}
